var journalize = require('journalize');

import { capfirst, apdate, aptime, apmonth } from 'journalize';

import { LENGTH_OF_CHECK_INTERVAL } from './constants';

const PARTY_SORT_ORDER = [
  'Republican',
  'Democrat',
  'Libertarian',
  'Green',
  'Independent',
  'Write-in',
];

const TT_directory_slugs = [
  { office: 'Texas House', 'directory-slug': 'tx-house' },
  { office: 'Texas Senate', 'directory-slug': 'tx-senate' },
  { office: 'U.S. House', 'directory-slug': 'us-house' },
  { office: 'State Board of Education', 'directory-slug': 'sboe' },
];

function get_directory_slug(office) {
  return TT_directory_slugs.filter(slug => slug.office == office);
}

function sort_candidates_by_party(candidates) {
  return candidates.sort(
    (a, b) =>
      PARTY_SORT_ORDER.indexOf(a.party) - PARTY_SORT_ORDER.indexOf(b.party)
  );
}

function countdown(minutes) {
  var seconds = 60;

  var now = new Date().getTime();
  // target timestamp; we will compute the remaining time
  // relative to this date.
  var target = new Date(now + LENGTH_OF_CHECK_INTERVAL);
  // update frequency; note, this is flexible, and when the tab is
  // inactive, there are no guarantees that the countdown will update
  // at this frequency.
  var update = 500;

  var int = setInterval(function() {
    var countdown_div = document.querySelectorAll('.countdown');
    // current timestamp
    var now = new Date();
    // remaining time, in seconds
    var remaining = (target - now) / 1000;

    // if done, alert
    if (remaining < 1 && remaining > 0) {
      Array.prototype.forEach.call(countdown_div, function(el) {
        el.innerHTML = 'Updating';
      });
      return;
    }

    if (remaining < 0) {
      clearInterval(int);
      return;
    }

    // format
    var minutes = ~~(remaining / 60);
    var seconds = ~~(remaining % 60);

    // display
    Array.prototype.forEach.call(countdown_div, function(el) {
      el.innerHTML =
        "Update in <span class='counter'>" +
        format(minutes) +
        ':' +
        format(seconds) +
        '</span>';
    });
  }, update);
}

const delay = (function() {
  var timer = 0;
  return function(callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})(); 

function lastUpdated(now) {
  // format dates to ap style
  const formatted_date = journalize.apdate(now),
    formatted_time = journalize.aptime(now).replace(/\./g, ''),
    formatted_month = journalize.apmonth(now),
    just_day = now.getDate();

  // A delay function so we can give a little time for the div .countdown to exist
  const delay = (function() {
    var timer = 0;
    return function(callback, ms) {
      clearTimeout(timer);
      timer = setTimeout(callback, ms);
    };
  })(); 

  delay(function() {
    var countdown_div = document.querySelectorAll('.countdown');
    Array.prototype.forEach.call(countdown_div, function(el) {
      el.innerHTML =
        "Last updated <span class='counter'>" +
        // formatted_month + ' ' + just_day + ', ' +
        formatted_time +
        '</span>';
    });
  }, 600); // end delay
}

function lastUpdatedFormat(now) {
  // format dates to ap style
  const formatted_date = journalize.apdate(now),
    formatted_time = journalize.aptime(now).replace(/\./g, ''),
    formatted_month = journalize.apmonth(now),
    just_day = now.getDate();

  return formatted_time;
}

function format(num) {
  return num < 10 ? '0' + num : num;
}

const chunk = (arr, size) =>
  arr.reduce((acc, _, i) => {
    if (i % size === 0) acc.push(arr.slice(i, i + size));
    return acc;
  }, []);

function determineDistrictTitle(contest) {
  return `${contest.office} ${
    contest.office === 'President' || contest.division_type === 'class'
      ? ''
      : contest.division_type === 'place' && contest.office_division === 1
      ? 'Chief Justice'
      : capfirst(contest.division_type) + ' ' + contest.office_division
  }`.trim();
}

function determineContestTitle(contest, isPartner) {
  if (
    (contest.division_type === null ||
      contest.division_type == 'class' ||
      contest.division_type === 'seat') &&
    isPartner !== 'isPartner'
  )
    return '';
  else if (
    (contest.division_type === null ||
      contest.division_type == 'class' ||
      contest.division_type === 'seat') &&
    isPartner == 'isPartner'
  )
    return `${contest.office}`;
  else return determineDistrictTitle(contest);
}

function determineContestTitleYourRaces(contest) {
  return determineDistrictTitle(contest);
}

export {
  get_directory_slug,
  sort_candidates_by_party,
  countdown,
  delay,
  lastUpdated,
  lastUpdatedFormat,
  chunk,
  determineDistrictTitle,
  determineContestTitle,
  determineContestTitleYourRaces,
};